import React from "react";
import { ResponsiveLine } from "@nivo/line";

// const data = [
//   {
//     id: "Line 1",
//     data: [
//       { x: "A", y: 50 },
//       { x: "B", y: 150 },
//       // Add more data points as needed
//     ],
//   },
//   {
//     id: "Line 2",
//     data: [
//       { x: "A", y: 100 },
//       { x: "B", y: 100 },
//       // Add more data points as needed
//     ],
//   },
// ];

const LineChart = ({ data, axisBottom = {}, axisLeft = {}, width }) => {
  const customColors = ["#FF5733", "#F2A900", "#00B398"]; // Add your custom colors here

  return (
    <div style={{ height: "400px", width, minWidth: "100%" }}>
      <ResponsiveLine
        data={data}
        colors={customColors}
        margin={{ top: 50, right: 60, bottom: 50, left: 60 }}
        xScale={{ type: "point" }}
        yScale={{ type: "linear", min: "auto", max: "auto", stacked: false, reverse: false }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "transportation",
          legendOffset: 36,
          legendPosition: "middle",
          ...axisBottom,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "count",
          legendOffset: -40,
          legendPosition: "middle",
          ...axisLeft,
        }}
        pointSize={10}
        pointColor={{ from: "color", modifiers: [] }}
        pointBorderWidth={2}
        pointBorderColor={{ from: "serieColor" }}
        pointLabelYOffset={-12}
        useMesh
        enableGridX
        enableGridY
      />
    </div>
  );
};

export default LineChart;
